import { IObservable, Subject } from '~/rage/utils';
import { IPhoneGpsLocation, IVector3, MapPointCategory } from '~/shared';
import { IGpsService } from './gpsServiceTypes';

const STUB_COUNT = 15;

const ALL_CATEGORIES: MapPointCategory[] = [
	MapPointCategory.IMPORTANT,
	MapPointCategory.WORK,
	MapPointCategory.BANK,
	MapPointCategory.SHOP,
	MapPointCategory.CLOTHES_SHOP,
	MapPointCategory.HOBBY,
	MapPointCategory.HOSPITAL,
	MapPointCategory.TATTOO_SALON,
	MapPointCategory.HAIR_SALON,
	MapPointCategory.TUNING_STATION,
	MapPointCategory.CAR_SHOWROOM,
	MapPointCategory.GAS_STATION,
	MapPointCategory.BUYERS,
	MapPointCategory.PAINTING,
	MapPointCategory.VEHICLE_TUNING,
];

const STUB_LABELS: Record<MapPointCategory, string[]> = {
	[MapPointCategory.IMPORTANT]: [
		'Монумент в честь релиза сервера',
		'Центральная площадь',
		'Смотровая площадка',
		'Парк отдыха',
		'Набережная',
		'Площадь у фонтана',
		'Туристический центр',
		'Информационный киоск',
		'Мемориал',
		'Памятник основателям',
		'Обзорная точка моста',
		'Зона ивентов',
		'Кинотеатр под открытым небом',
		'Ярмарка',
		'Амфитеатр',
	],
	[MapPointCategory.WORK]: [
		'Стройка CENTRAL',
		'Склад грузов',
		'Автопарк такси',
		'База дальнобоя',
		'Курьерский хаб',
		'Офис логистики',
		'Цех упаковки',
		'Автомойка коммерческая',
		'Пункт выдачи заказов',
		'Сервисная станция',
		'Ремонтная мастерская',
		'База перевозок',
		'Сортировочный центр',
		'Погрузочный терминал',
		'Дежурная смена охраны',
	],
	[MapPointCategory.BANK]: [
		'Банк — филиал Вест',
		'Банк — филиал Ист',
		'Банкоматная зона A',
		'Банкоматная зона B',
		'Отделение премиум',
		'Касса обмена валют',
		'Банк у автовокзала',
		'Банк у госуслуг',
		'Ночная касса',
		'Ипотечный офис',
		'Бизнес-банкинг',
		'Сейфовые ячейки',
		'Регистрация счёта',
		'Кредитный отдел',
		'Отделение 24/7',
	],
	[MapPointCategory.SHOP]: [
		'24/7 — Грув-стрит',
		'24/7 — Инносент',
		'24/7 — Палето-бэй',
		'24/7 — Сэнди',
		'24/7 — Хармони',
		'24/7 — Миррор-парк',
		'24/7 — Дель-Пьеро',
		'24/7 — Рокфорд',
		'24/7 — Центр',
		'24/7 — Вайнвуд',
		'24/7 — Строберри',
		'24/7 — Ла-Пуэрта',
		'24/7 — Дэвис',
		'24/7 — Чумач',
		'24/7 — Алгонквин',
	],
	[MapPointCategory.CLOTHES_SHOP]: [
		'Бинко — деловой стиль',
		'Бинко — спорт',
		'Понсонбис',
		'Субурбан',
		'Discount Store',
		'Одежда — премиум',
		'Одежда — униформа',
		'Вещевой рынок',
		'Second hand',
		'Аксессуары и ремни',
		'Обувь и сумки',
		'Горнолыжная коллекция',
		'Пляжная линейка',
		'Уличная мода',
		'Вечерний выход',
	],
	[MapPointCategory.HOBBY]: [
		'Рыбалка — озеро',
		'Рыбалка — пирс',
		'Тренажёрный зал открытый',
		'Йога-парк',
		'Скейт-зона',
		'Беговая дорожка у моря',
		'Стрельбище хобби',
		'Мастерская DIY',
		'Керамика и гончарка',
		'Музыкальная студия',
		'Фотостудия',
		'Квест-комната',
		'Настольные игры',
		'Антикварный клуб',
		'Коллекционный рынок',
	],
	[MapPointCategory.HOSPITAL]: [
		'Больница Sandy Shores',
		'Клиника Пиллбокс',
		'Травмпункт CENTRAL',
		'Поликлиника WEST',
		'Детская клиника',
		'Реабилитация',
		'Лаборатория анализов',
		'Скорая база',
		'Психологическая помощь',
		'Стоматология',
		'Оптика и слух',
		'Вакцинационный пункт',
		'Диспансер',
		'Хоспис',
		'Медцентр 24/7',
	],
	[MapPointCategory.TATTOO_SALON]: [
		'Тату — классика',
		'Тату — олд-скул',
		'Тату — реализм',
		'Тату — минимализм',
		'Тату — япония',
		'Тату — блэкворк',
		'Тату — кавер',
		'Пирсинг-студия',
		'Тату и барбер',
		'Гост-артисты',
		'Салон на Вайнвуде',
		'Салон на Веспучи',
		'Салон у пляжа',
		'Кабинет художника',
		'Студия кастома',
	],
	[MapPointCategory.HAIR_SALON]: [
		'Барбершоп — центр',
		'Барбершоп — запад',
		'Салон укладок',
		'Косметология волос',
		'Мужской зал',
		'Женский зал',
		'VIP-кабинет',
		'Детский стилист',
		'Окрашивание',
		'Кератин',
		'Борода и усы',
		'Экспресс-стрижка',
		'Салон у метро',
		'Салон у торгового',
		'Ночной барбер',
	],
	[MapPointCategory.TUNING_STATION]: [
		'Тюнинг — мотор',
		'Тюнинг — подвеска',
		'Тюнинг — тормоза',
		'Тюнинг — турбо',
		'Тюнинг — выхлоп',
		'Тюнинг — карбон',
		'Детейлинг',
		'Шиномонтаж PRO',
		'Развал-схождение',
		'Диностенд',
		'Кастом фар',
		'Обвесы',
		'Нитро-блок',
		'Спорт-кит',
		'Шоурум деталей',
	],
	[MapPointCategory.CAR_SHOWROOM]: [
		'Автосалон — масс-маркет',
		'Автосалон — премиум',
		'Автосалон — спорт',
		'Автосалон — внедорожники',
		'Автосалон — электро',
		'Б/у центр',
		'Лизинговый зал',
		'Тест-драйв площадка',
		'Сервис дилера',
		'Предзаказ моделей',
		'Трейд-ин отдел',
		'Страхование у дилера',
		'Кредит на авто',
		'Выдача ключей',
		'VIP-консьерж',
	],
	[MapPointCategory.GAS_STATION]: [
		'АЗС — северная',
		'АЗС — южная',
		'АЗС — трасса 1',
		'АЗС — трасса 2',
		'АЗС — город A',
		'АЗС — город B',
		'АЗС — дизель',
		'АЗС — премиум топливо',
		'Компрессор и вода',
		'Мини-маркет при АЗС',
		'Зарядка электро',
		'Трак-стоянка',
		'Ночная АЗС',
		'АЗС у порта',
		'АЗС у аэропорта',
	],
	[MapPointCategory.BUYERS]: [
		'Скупщик — металл',
		'Скупщик — техника',
		'Скупщик — драгоценности',
		'Скупщик — антиквар',
		'Скупщик — автозапчасти',
		'Скупщик — одежда люкс',
		'Скупщик — арт',
		'Скупщик — коллекции',
		'Оптовый выкуп',
		'Ночной скуп',
		'Скупщик — рыбалка',
		'Скупщик — охота',
		'Скупщик — ферма',
		'Скупка под заказ',
		'Экспресс-оценка',
	],
	[MapPointCategory.PAINTING]: [
		'Покраска — стандарт',
		'Покраска — металлик',
		'Покраска — мат',
		'Покраска — перламутр',
		'Покраска — хамелеон',
		'Аэрография',
		'Винил и плёнка',
		'Защитное покрытие',
		'Полировка кузова',
		'Покраска дисков',
		'Покраска суппортов',
		'Реставрация лака',
		'Камуфляж',
		'Гоночная ливрея',
		'Кастом-градиент',
	],
	[MapPointCategory.VEHICLE_TUNING]: [
		'Чип-тюнинг',
		'Калибровка ECU',
		'Настройка КПП',
		'Спорт-прошивка',
		'Диагностика CAN',
		'Удаление ограничителей',
		'Эко-калибровка',
		'Трек-режим',
		'Стендовая настройка',
		'Логирование заездов',
		'Подбор передаточных',
		'Launch control',
		'Круиз-контроль PRO',
		'Адаптация под E85',
		'Сервис контроллеров',
	],
};

const STUB_ID_PREFIX: Record<MapPointCategory, string> = {
	[MapPointCategory.IMPORTANT]: 'important',
	[MapPointCategory.WORK]: 'work',
	[MapPointCategory.BANK]: 'bank',
	[MapPointCategory.SHOP]: 'shop',
	[MapPointCategory.CLOTHES_SHOP]: 'clothes_shop',
	[MapPointCategory.HOBBY]: 'hobby',
	[MapPointCategory.HOSPITAL]: 'hospital',
	[MapPointCategory.TATTOO_SALON]: 'tattoo_salon',
	[MapPointCategory.HAIR_SALON]: 'hair_salon',
	[MapPointCategory.TUNING_STATION]: 'tuning_station',
	[MapPointCategory.CAR_SHOWROOM]: 'car_showroom',
	[MapPointCategory.GAS_STATION]: 'gas_station',
	[MapPointCategory.BUYERS]: 'buyers',
	[MapPointCategory.PAINTING]: 'painting',
	[MapPointCategory.VEHICLE_TUNING]: 'vehicle_tuning',
};

function stubPosition(i: number, seed: number): IVector3 {
	return {
		x: Math.round((-1600 + ((i * 241 + seed * 17) % 3200)) * 100) / 100,
		y: Math.round((-3600 + ((i * 183 + seed * 29) % 4800)) * 100) / 100,
		z: Math.round((22 + ((i * 13 + seed * 5) % 38)) * 100) / 100,
	};
}

function makeStubCategory(
	category: MapPointCategory,
	seed: number,
): IPhoneGpsLocation[] {
	const labels = STUB_LABELS[category];
	const prefix = STUB_ID_PREFIX[category];
	return labels.slice(0, STUB_COUNT).map((label, i) => ({
		id: `${prefix}_${i + 1}`,
		category,
		label,
		position: stubPosition(i, seed),
	}));
}

function buildMapPoints(): Record<MapPointCategory, IPhoneGpsLocation[]> {
	return ALL_CATEGORIES.reduce(
		(acc, cat, idx) => {
			acc[cat] = makeStubCategory(cat, idx + 1);
			return acc;
		},
		{} as Record<MapPointCategory, IPhoneGpsLocation[]>,
	);
}

export class GpsServiceStub implements IGpsService {
	private readonly categories: IObservable<MapPointCategory[]> = new Subject<
		MapPointCategory[]
	>(ALL_CATEGORIES);
	private readonly playerPosition = new Subject<IVector3>({ x: 0, y: 0, z: 0 });
	private readonly activeRoute = new Subject<IPhoneGpsLocation | null>(null);

	private readonly mapPoints = new Subject<
		Record<MapPointCategory, IPhoneGpsLocation[]>
	>(buildMapPoints());

	public getAvaliableCategories(): IObservable<MapPointCategory[]> {
		return this.categories;
	}

	public getMapPoints(): IObservable<
		Record<MapPointCategory, IPhoneGpsLocation[]>
	> {
		return this.mapPoints;
	}

	public getPlayerPosition(): IObservable<IVector3> {
		return this.playerPosition;
	}

	public getActiveRoute(): IObservable<IPhoneGpsLocation | null> {
		return this.activeRoute;
	}

	public async setTargetRoute(route: IPhoneGpsLocation): Promise<void> {
		console.log('gps:setTargetRoute', route.position);
		this.activeRoute.next(route);
	}

	public async clearTargetRoute(): Promise<void> {
		console.log('gps:clearTargetRoute');
		this.activeRoute.next(null);
	}
}
